export default __webpack_public_path__ + "static/media/23.fd9bd5b2.svg";